import comp from '../components/barrel';
import svg from '../js/svg';
import listReturnState from '../js/listReturnState';

const EP = 'files/get-email-templates';

function formatDynamicMarkers(val) {
  if (val == null) return '—';
  if (Array.isArray(val) && val.length) {
    return val.map((m) => String(m).trim()).filter(Boolean).join(', ');
  }
  if (typeof val === 'string') {
    const t = val.trim();
    return t !== '' ? t : '—';
  }
  return '—';
}

export default {
  async prepare() {
    this.recipe.methods.push(await O.mPOST(EP, {}));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const res = data[EP];
    const rows = res && res.data && Array.isArray(res.data) ? res.data : [];
    this.buildTableHead();
    await this.buildTableBody(rows);
  },

  buildTableHead() {
    const tableHead = U.id('emailTemplatesTableHead');
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();

    // Action (icon link to detail) — no heading, same as ManageUsers / ManageOrganisation
    headRow.insertCell(0);

    const thName = headRow.insertCell(1);
    thName.innerHTML = 'Template name';

    const thSubject = headRow.insertCell(2);
    thSubject.innerHTML = 'Subject';

    const thDesc = headRow.insertCell(3);
    thDesc.innerHTML = 'Description';

    const thActive = headRow.insertCell(4);
    thActive.innerHTML = 'Active';

    const thMarkers = headRow.insertCell(5);
    thMarkers.innerHTML = 'Dynamic markers';

    const thSender = headRow.insertCell(6);
    thSender.innerHTML = 'Sender email';

    const thUpdated = headRow.insertCell(7);
    thUpdated.innerHTML = 'Updated';
  },

  async buildTableBody(listData) {
    const tbody = U.id('emailTemplatesTableBody');
    tbody.innerHTML = '';

    if (!listData.length) {
      const tr = tbody.insertRow();
      const cell = tr.insertCell(0);
      cell.colSpan = 8;
      cell.innerHTML = 'No email templates found.';
      return;
    }

    for (const row of listData) {
      const tr = tbody.insertRow();

      const openDetail = tr.insertCell(0);
      const linkSVG = svg.linkNewPage();
      linkSVG.style.cursor = 'pointer';
      linkSVG.setAttribute('role', 'button');
      linkSVG.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        listReturnState.save('Email_template_detail', {
          listPage: 'Email_templates',
          state: {},
        });
        O.PREP('Email_template_detail', `template_uuid=${row.template_uuid}`);
      });
      openDetail.appendChild(linkSVG);

      const nameCell = tr.insertCell(1);
      nameCell.textContent = row.template_name != null && row.template_name !== '' ? row.template_name : '—';

      const subjectCell = tr.insertCell(2);
      subjectCell.textContent = row.subject_template != null ? row.subject_template : '—';

      const descCell = tr.insertCell(3);
      descCell.textContent = row.description != null && row.description !== '' ? row.description : '—';

      const activeCell = tr.insertCell(4);
      const statusEl = await comp.statusTag(row.active_yn ? 'Active' : 'Inactive');
      activeCell.appendChild(statusEl);

      const markersCell = tr.insertCell(5);
      markersCell.textContent = formatDynamicMarkers(row.dynamic_markers);

      const senderCell = tr.insertCell(6);
      senderCell.textContent = row.sender_email != null && row.sender_email !== '' ? row.sender_email : '—';

      const updatedCell = tr.insertCell(7);
      if (row.updated_date) {
        try {
          updatedCell.textContent = new Date(row.updated_date).toLocaleString();
        } catch {
          updatedCell.textContent = String(row.updated_date);
        }
      } else {
        updatedCell.textContent = '—';
      }
    }
  },
};
